import { useEffect } from 'react';

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} — Liam Boyd` : 'Liam Boyd';
    return () => { document.title = 'Liam Boyd'; };
  }, [title]);
}
